import {Injectable} from '@angular/core';
import { environment } from 'src/environments/environment';
import {BehaviorSubject} from 'rxjs';

@Injectable()
export class FeaturesService {
  private features = new BehaviorSubject(environment.features);
  public features$ = this.features.asObservable();

  public active(feature) {
    const features = this.features.getValue();
    return features[feature] && features[feature].active;
  }
}
